export default function Scale() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Scale</h1>
      <p>Content for Scale goes here.</p>
    </div>
  );
}